let pwaInstallPrompt: Event | null = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  pwaInstallPrompt = e;
});

export function getPwaInstallPrompt() {
  return pwaInstallPrompt;
}

export function removePwaInstallPrompt() {
  pwaInstallPrompt = null;
}
